<div class="widget-list-item" [class.selected]="widget().isSelected" (click)="toggleWidgetSelection()">
    @if (widget().isAddedToDashboard) {
        <div
            class="added-indicator"
            appTooltip
            [componentData]="'dashboard.visuals.addModal.alreadyAdded' | translate"
            position="top"
            trigger="hover"
        >
            <i class="fa fa-check"></i>
        </div>
    }

    <div class="selection-indicator">
        @if (widget().isSelected) {
            <i class="fa fa-check-circle"></i>
        } @else {
            <i class="fa-light fa-circle-dashed"></i>
        }
    </div>

    <div class="widget-image-container">
        <img [src]="widgetImageSrc()" [alt]="widgetTitle() | translate" />
    </div>

    <div class="widget-content">
        <h3 class="widget-title">{{ widgetTitle() | translate }}</h3>

        <div class="widget-description" [class.expanded]="isExpanded()">
            <p [innerHTML]="widgetDisplayDescription()"></p>
        </div>

        @if (shouldShowToggleButton()) {
            <button type="button" class="toggle-button" (click)="toggleDescription($event)">
                @if (isExpanded()) {
                    <span>{{ 'dashboard.visuals.addModal.showLess' | translate }}</span>
                } @else {
                    <span>{{ 'dashboard.visuals.addModal.showMore' | translate }}</span>
                }
            </button>
        }

        @if (widget().isSelected && hasMultipleSizes()) {
            <app-visuals-dashboard-size-picker
                [availableSizes]="widget().sizes"
                (emitSelectedSize)="onSizeSelected($event)"
            ></app-visuals-dashboard-size-picker>
        }

        @if (widget().isSelected && hasPeriodSelection()) {
            <app-visuals-dashboard-period-picker
                [selectedOptionValue]="inititalSelectedPeriod()"
                (periodChange)="onPeriodChange($event)"
            ></app-visuals-dashboard-period-picker>
        }
    </div>
</div>
